import { useEffect } from 'react';

export const useCanonicalUrl = (path: string) => {
  const url = `${ window.location.origin }${ path }`;

  useEffect(() => {
    let element = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    const existedBeforeMount = !!element;
    const previousHref = element?.getAttribute('href') ?? null;

    if (!element) {
      element = document.createElement('link');
      element.setAttribute('rel', 'canonical');
      document.head.appendChild(element);
    }

    element.setAttribute('href', url);

    return () => {
      if (existedBeforeMount) {
        if (previousHref !== null) {
          element?.setAttribute('href', previousHref);
        }
      } else {
        element?.remove();
      }
    }
  }, [ url ]);
};
